<template>
    <q-layout view="hHh lpR fFf">
        <CusHeader :title="topTitle" @onClickBack="onBack" />
        <UserPW v-if="!isPassed" v-model:isValid="isPassed" />
        <q-page-container v-if="isPassed">
            <q-page>
                <div class="q-pa-xl full-screen flex item-center + justify-center">
                    <div style="margin: 10px 20vw; width: 100%">
                        <p class="mapTt30">내 정보</p>

                        <!-- <p class="text-h5 text-bold">내 정보</p> -->
                        <div>
                            <p class="mypageTtInfoTitle30 layoutTitle">이름</p>
                            <!-- <p class="title">이름</p> -->
                            <!-- <p class="text-h6 text-bold">{{ wUserName }}</p> -->
                            <p class="mg_top_16 mypageTtInfoTitle40">{{ wUserName }}</p>

                            <q-form ref="FormRefPW" style="margin: 0 auto">
                                <p class="mg_top_52 mypageTtInfoTitle30 layoutTitle">비밀번호</p>
                                <q-input
                                    outlined
                                    type="password"
                                    v-model="wPassword"
                                    :disable="isDisablePWinput"
                                    style="width: 100%; margin: 1.33vmin 0 0"
                                    bg-color="white"
                                    clearable
                                    clear-icon="close"
                                    lazy-rules
                                    :rules="[(val) => checkPassword(val) || '비밀번호는 5~20자 의 영문,숫자,특수문자 조합으로 입력해 주세요.']"
                                />
                                <!-- :rules="[(val) => (val && val.length > 0) || '비밀번호를 입력해 주세요.', validMinLength2, validMaxLength20]" -->
                                <p class="mg_top_16 mypageTtInfoTitle30 layoutTitle">비밀번호 확인</p>
                                <q-input
                                    outlined
                                    type="password"
                                    v-model="wPasswordCheck"
                                    :disable="isDisablePWinput"
                                    style="width: 100%; margin: 1.33vmin 0 0"
                                    bg-color="white"
                                    clearable
                                    clear-icon="close"
                                    :rules="[(val) => (val ? true : `비밀번호를 다시 한번 입력해 주세요.`), (val) => val === wPassword || `비밀번호가 일치하지 않습니다. 다시 입력해 주세요.`]"
                                />
                                <!-- (val) => checkPassword(val) || '비밀번호는 5~20자 의 영문,숫자,특수문자 조합으로 입력해 주세요.', -->
                                <!-- (val) => val.length === 0 || '비밀번호를 다시 한번 입력해 주세요.', -->
                                <!-- :rules="[(val) => (val && val.length > 0) || '비밀번호를 다시 한번 입력해 주세요.', onCheckSame]" -->
                            </q-form>

                            <p class="mg_top_16 mypageTtInfoTitle30 layoutTitle">생년월일</p>
                            <p class="mg_top_16 mypageTtInfoTitle40">{{ wBirth }}</p>
                            <p class="mg_top_52 mypageTtInfoTitle30 layoutTitle">휴대폰번호 (학생)</p>
                            <p class="mg_top_16 mypageTtInfoTitle40">{{ wPhone }}</p>
                            <p class="mg_top_52 mypageTtInfoTitle30 layoutTitle">휴대폰번호 (학부모)</p>
                            <p class="mg_top_16 mypageTtInfoTitle40">{{ wPhoneParents }}</p>
                            <p class="mg_top_52 mypageTtInfoTitle30 layoutTitle">학교</p>
                            <p class="mg_top_16 mypageTtInfoTitle40">{{ wSchool }}</p>
                            <p class="mg_top_52 mypageTtInfoTitle30 layoutTitle">학년</p>
                            <p class="mg_top_16 mypageTtInfoTitle40">{{ getStringUserGrade }}</p>
                            <p class="mg_top_52 mypageTtInfoTitle30 layoutTitle">학원코드</p>
                            <p class="mg_top_16 mypageTtInfoTitle40">{{ wAcademyCode }}</p>

                            <div class="text-center">
                                <q-card-actions align="center">
                                    <CusButton :type="200" :label="`변경하기`" @onReturn="onSubmit" />

                                    <!-- <q-btn unelevated no-ripple :onClick="onSubmit" class="roundedBtnOutPrimary">
                                        <span class="roundedBtnTt30WHITE">변경하기</span>
                                    </q-btn> -->

                                    <!-- <CqBtn class="btn" color="primary" size="lg" style="width: 50%" label="변경하기" @click="onSubmit" /> -->
                                </q-card-actions>
                                <!-- <q-btn size="lg" style="margin-top: 60px; min-width: 300px; width: 60%; margin: 2px 0 0 0" class="mybtn text-h6" @click="onSubmit" type="submit" :disable="isDisableSubmitBtn" label="변경하기" /> -->
                            </div>
                        </div>
                    </div>
                </div>
            </q-page>
        </q-page-container>
    </q-layout>
</template>

<script setup>
import { onMounted, ref, computed, watch } from 'vue';
import CusHeader from '@/components/template/CusHeader.vue';
// import customHeader from '@/components/layouts/header/header.vue';
import CqBtn from '@/components/quasar/cqBtn.vue';
import UserPW from '@/views/myPage/userinfo/UserPW.vue';
import CusButton from '@/components/widget/CusButton.vue';
import Comm from '@/components/common.js';
import { checkPassword } from '@/helpers/utils';
import { getUserInfo, updatePw, checkPw } from '@/api/modules/mypage.js';
import { useQuasar } from 'quasar';
import { useRouter, useRoute } from 'vue-router';
import { GlobalStore } from '@/store';
import { DialogStore } from '@/store/modules/dialog';
import { monitoringLog } from '@/api/modules/monitoring';

const dStore = DialogStore();
const gStore = GlobalStore();
const router = useRouter();
const route = useRoute();
const $q = useQuasar();

const getStringUserGrade = computed(() => {
    return Comm.getHakNyoun(wGrade.value);
});
const topTitle = computed(() => {
    // console.log('--topTitle isPassed--', isPassed.value);
    return isPassed.value ? '내 정보' : '비밀번호 입력';
});

// watch(cbList1.value, (nObj) => {
//     isAll1.value.checked = nObj.filter((e) => e.checked).length === nObj.length;
// });
const isPassed = ref(false);
watch(isPassed.value, (nData) => {
    // console.log('--watch isPassed--', nData);
});
const FormRefPW = ref();
const wUserName = ref();
const wPassword = ref();
const wPasswordCheck = ref();
const wBirth = ref();
const wPhone = ref();
const wPhoneParents = ref();
const wSchool = ref();
const wGrade = ref();
const wAcademyCode = ref();

const isDisablePWinput = ref(false);
const isDisableSubmitBtn = ref(true);

// watch([wPassword, wPasswordCheck], (a, b) => {
//     isDisableSubmitBtn.value = !(wPassword.value && wPassword.value === wPasswordCheck.value);
// });

const defaultPw = '********';
const setUserData = async () => {
    const res = await getUserInfo(gStore.token);
    // console.log('--info-res-', res);
    if (res && res.status === 200) {
        const data = res.data.data;
        wUserName.value = data.studentName;
        // wPassword.value = defaultPw;
        // wPasswordCheck.value = defaultPw;
        wBirth.value = data.birthday;
        wPhone.value = data.studentPhone;
        wPhoneParents.value = data.protectorPhone;
        wSchool.value = data.schoolName;
        wGrade.value = data.grade;
        wAcademyCode.value = data.academyCode;
    }
};

onMounted(() => {
    setUserData();

    let data = {
        menuName: route.path.split('/').join(''),
    };
    monitoringLog(data, (res) => {
        console.log('userinfo monitoringLog API response ===', res);
    });
});
////////////////////////////----OnClick----////////////////////////////
const onSubmit = () => {
    isDisableSubmitBtn.value = true;
    // console.log('--onSubmit-wPassword.value-', wPassword.value);
    if (wPassword.value) {
        wPassword.value = wPassword.value.replace(/ /g, '');
        FormRefPW.value.validate().then(async (isValid) => {
            if (isValid) {
                // console.log('--(wPassword)--', wPassword.value);
                const res = await updatePw(gStore.token, wPassword.value);
                isDisableSubmitBtn.value = false;
                if (res) {
                    if (res.status === 200) {
                        if (route.path === '/userinfo')
                            dStore.openMsg('비밀번호 변경이 완료되었습니다.', (val) => {
                                router.push('/mypage');
                            });
                    } else {
                        if (route.path === '/userinfo')
                            dStore.errorMsg(`${res.data.message}`, () => {
                                router.go(router.currentRoute);
                            });
                    }
                }
            } else {
                isDisableSubmitBtn.value = false; // 비번변경 아님.
            }
        });
    } else router.push('/mypage');
};

const onBack = () => {
    // console.log('-userinfo-onBack--');
    router.push('/mypage');
    // router.push('/check');
};
const onHome = () => {
    router.push('/learninghome');
};
const validMinLength2 = (val) => (val.length < 2 ? '한글 또는 영문 2~20자로 입력해 주세요.' : true);
const validMaxLength20 = (val) => (val.length > 20 ? '한글 또는 영문 2~20자로 입력해 주세요.' : true);
</script>

<style scoped lang="scss">
.layoutTitle {
    margin: 10px 0 0 0;
}
p.title {
    margin: 10px 0 0 0;
    color: #8e8e8e;
}

.roundedBtnOutPrimary {
    width: 100%;
    padding: 2.5vmin 3.33vmin;
    border-radius: 1vmin;
    /* border: 1px solid black;  */
    background-color: #8e43f0;
}
//////// qqquasarDeep
::v-deep {
    input {
        padding: 1.6vw;
        font-size: 1.2vw;
        color: $color_gray_900;
        line-height: 1.6vw;

        ::placeholder {
            color: $color_gray_600;
        }
    }

    .q {
        &-field {
            margin-top: 0px;

            &__bottom {
                font-size: 1.1vw;
                font-weight: 500;
                line-height: 1.4vw;

                &--animated {
                    padding-top: 5px;
                }
            }

            &__control {
                border-radius: 1vmin;
                height: 100%;
            }

            &__label {
                top: 50%;
                left: 1.6vw;
                font-size: 1.2vw;
                color: $color_gray_600;
                line-height: 1.6vw;
                transform: translateY(-50%);
            }

            &--with-bottom {
                // padding-bottom: 3vmin;
                padding-bottom: 1.8vw;
            }

            &--float {
                .q-field__label {
                    top: 0.8vw;
                    font-size: 0.8vw;
                    @include transform(translateY(-40%));
                }
            }
        }

        &-item__label {
            font-size: 24px;
        }

        &-btn {
            width: 44%;
            max-width: 435px;
        }

        &-card__actions {
            padding: 0;
            margin-top: 9.17vmin;
        }
    }

    .text-negative {
        &.q-icon {
            display: none;
        }
    }
}

.mapTt30 {
    margin-bottom: 9.25vmin;
}

.mg_top_52 {
    margin-top: 4.33vmin;
}
</style>
